export default __webpack_public_path__ + "static/media/260px-Headshot.1acd1e4a.webp";